import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ErrorToast, SuccessToast } from '../../components';
import { getUserRegisterFromLS } from '../../helpers/localstorage-helper';
import { LOGIN } from '../../routes/routes';

interface UpdateProfileDetailsType {
  creationType?: number;
  token?: string | undefined;
  name: string;
  surname: string;
  username: string;
  genderType: number;
  address: string;
  zipCode: string;
  city: string;
  country: string;
  countryCode: string;
  history: any;
  userId?: number;
}

export const updateProfileDetails = createAsyncThunk(
  'auth/updateProfileDetails',
  async (
    {
      userId,
      name,
      surname,
      username,
      genderType,
      address,
      zipCode,
      city,
      country,
      countryCode,
      history
    }: UpdateProfileDetailsType,
    { rejectWithValue }
  ) => {
    try {
      await axios.put(`/authorization/signup/profile/details`, {
        userId,
        name,
        surname,
        username,
        genderType,
        address,
        zipCode,
        city,
        country,
        countryCode
      });

      SuccessToast(
        'Thank you for registering to UnitedOne.',
        'Please sign in to your new account to complete the registration.'
      );

      history.push(LOGIN);

      getUserRegisterFromLS();
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

export const updateSocialProfileDetails = createAsyncThunk(
  'auth/updateSocialProfileDetails',
  async (
    {
      token,
      name,
      surname,
      username,
      genderType,
      address,
      zipCode,
      city,
      country,
      countryCode,
      history
    }: UpdateProfileDetailsType,
    { rejectWithValue }
  ) => {
    try {
      await axios.put(`/authorization/signup/social/profile/details`, {
        token,
        name,
        surname,
        username,
        genderType,
        address,
        zipCode,
        city,
        country,
        countryCode
      });

      SuccessToast(
        'Thank you for registering to UnitedOne.',
        'Please sign in to your new account to complete the registration.'
      );

      history.push(LOGIN);

      getUserRegisterFromLS();
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
